export enum PasswordResetOrigin {
  ORIGIN_DASHBOARD = 0,
}
